module.exports = __webpack_public_path__ + "static/media/solutions.a4380157.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headers/solutions.jpg
// module id = 625
// module chunks = 11